/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_OverlineInputs */

const en_mk_tut_overline = /** @type {(inputs: Mk_Tut_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The complete guide`)
};

const id_mk_tut_overline = /** @type {(inputs: Mk_Tut_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panduan lengkap`)
};

/**
* | output |
* | --- |
* | "The complete guide" |
*
* @param {Mk_Tut_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_overline = /** @type {((inputs?: Mk_Tut_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_overline(inputs)
	return en_mk_tut_overline(inputs)
});